import { render, staticRenderFns } from "./TruckDriver.vue?vue&type=template&id=50c7cc7b&"
import script from "./TruckDriver.vue?vue&type=script&lang=js&"
export * from "./TruckDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports